import type { AppProps } from 'next/app';
import { ApplicationInsights } from '../appInsights';
import { useEffect } from 'react';
import tracker from '../tracker';
import '@ingeniorforeningen/figurine-core/styles.css';
import '@ingeniorforeningen/figurine-cms/styles.css';

const App = ({ Component, pageProps }: AppProps) => {
  useEffect(() => {
    tracker().trackPageView(pageProps?.data?.page?.metadata);
  }, [pageProps?.data?.page?.metadata]);

  return (
    <ApplicationInsights>
      <Component {...pageProps} />
    </ApplicationInsights>
  );
};

export default App;
